import { Popup } from 'semantic-ui-react';
import React, { useMemo, useState } from 'react';
import { Props } from '../../interfaces/GenericTableRowDataProps';
import { Row } from './Row';
import { SubItemsRow } from './SubItemsRow';

import './Row.less';

export const TableRow = <TData, TField, TDataSubItem = TData>(
  props: Props<TData, TField, TDataSubItem>
) => {
  const {
    expandableRowContent,
    tableAccordionActiveItem,
    toggleAccordion,
    item,
  } = props;
  const [isSubItemsOpened, setIsSubItemsOpened] = useState(false);
  const isItemHasSubItems =
    props.keyNameSubItemsProperty &&
    Array.isArray((props.item as any)[props.keyNameSubItemsProperty]) &&
    (props.item as any)[props.keyNameSubItemsProperty].length > 0;

  const toolTipText = (): string => {
    return props.toolTip?.content(props.item) ?? '';
  };
  const isAccordion = useMemo(
    () => expandableRowContent && toggleAccordion,
    [expandableRowContent, toggleAccordion]
  );

  const toggleSubItems = (isSubItemsOpened: boolean) => {
    isAccordion &&
      toggleAccordion &&
      toggleAccordion(
        isSubItemsOpened ? (props.item as { id: string }).id.toString() : null
      );
    setIsSubItemsOpened(isSubItemsOpened);
  };

  const isExpanded = useMemo(() => {
    return isAccordion
      ? tableAccordionActiveItem === (item as { id: string }).id &&
          isSubItemsOpened
      : isSubItemsOpened;
  }, [tableAccordionActiveItem, isSubItemsOpened, isAccordion, item]);

  return (
    <React.Fragment>
      {props.toolTip?.show && toolTipText() ? (
        <>
          <Popup
            {...props.toolTip}
            content={toolTipText()}
            trigger={Row(props, isItemHasSubItems, isExpanded, toggleSubItems)}
          />
          {SubItemsRow(props, isItemHasSubItems, isExpanded)}
        </>
      ) : (
        <>
          {Row(props, isItemHasSubItems, isExpanded, toggleSubItems)}
          {SubItemsRow(props, isItemHasSubItems, isExpanded)}
        </>
      )}
    </React.Fragment>
  );
};
